import { createRoutine, promisifyRoutine } from 'redux-saga-routines';

// get inventory
export const getInventory = createRoutine('inventory/getInventory');
// pdf
export const inventoryPdf = createRoutine('inventory/inventoryPdf');
export const inventoryPdfPromiseCreator = promisifyRoutine(inventoryPdf);
